<template>
    <z-backForm :name="'back-taskTime'" :align="true" @save="saveSet" @cancel="backSet" v-loading.fullscreen.lock="full_screenFlag">
        <!-- <div class="back-item">
            <div class="back-title">允许流转时间</div>
            <div class="back-wrap">
                <el-input class="top-choose" rule="noVal number" v-tar="sub[0]" v-model="sub[0]" >
                    <template slot="append">工作日</template>
                </el-input>
                <div class="tip">超过时间则不可以流转</div>
            </div>
        </div> -->
        <div class="back-item">
            <div class="back-title">等待接收时间</div>
            <div class="back-wrap">
                <el-input class="top-choose" rule="noVal number" v-tar="accept_time" v-model="accept_time" >
                    <template slot="append">工作日</template>
                </el-input>
                <div class="tip">超过时间则开具罚单</div>
            </div>
        </div>
    </z-backForm>
</template>

<script>
    export default {
        data(){
            return {
                accept_time:"", //接收时间
                full_screenFlag:false, //全屏遮罩
            }
        },

        created(){
            this.getData();
        },
        methods:{
            getData(){
                let url = "api/clerk/cfg_task";
                this.$http.get(url).then(res=>{
                    if(res.status == 200){
                        this.accept_time = res.res_data.taskWaitDays;
                        this.$form.init("back-taskTime");
                    }
                });
            },
            saveSet(){
                this.full_screenFlag = true;
                let url = "api/admin/cfg_task";
                let obj = {
                    task_wait_days:this.accept_time,
                }
                this.$http.put(url,obj).then(res=>{
                    if(res.status == 200){
                        this.getData();
                        this.successTip("保存成功");
                    }
                    this.full_screenFlag = false;
                }).catch(err=>{
                    this.full_screenFlag = false;
                    this.errorTip("保存失败");  
                });
            },
            backSet(dataArr){
                [this.accept_time] = dataArr;
            }
        },
    }
</script>

<style lang="less">

</style>


// WEBPACK FOOTER //
// taskTime.vue?628dc4c8